import styles from "./Mockup.module.css";
import { MockupProjectGalleryInterface } from "../../../../../../../lib/types/mockupProjectGallery";
import { urlFor } from "../../../../../../../lib/sanity.client";
import { getVideoUrl } from "../../../../../../../lib/sanity.client";
import { useEffect, useRef } from "react";

export type MockupProps = {
    mockupPG: MockupProjectGalleryInterface[];
};

const Mockup = (props: MockupProps) => {
    return (
        <>
            {props.mockupPG && (
                <div className={styles.container}>
                    {props.mockupPG.map((mockup, index) => (
                        <>
                            {mockup.images && (
                                <div
                                    className={`${
                                        mockup.images.length > 1
                                            ? styles.multiple
                                            : styles.normal
                                    }`}
                                    key={index}
                                >
                                    {mockup.images.map((image, index) => (
                                        <img
                                            key={index}
                                            src={urlFor(image).url()}
                                            alt={`Mockup ${index + 1}`}
                                        />
                                    ))}
                                </div>
                            )}
                            {mockup.videos && (
                                    <div
                                        className={`${
                                            mockup.videos.length > 1
                                                ? mockup.isVideoMobile ? styles.sideToSide : styles.multipleVideo
                                                : mockup.isVideoMobile ? styles.sideToSideNormal : styles.normalVideo
                                        }`}
                                        key={index}
                                    >
                                        {mockup.videos.map((video, index) => (
                                            <div className={styles.videoStyles}>
                                                <video
                                                    key={index}
                                                    controls
                                                    className={styles.video}
                                                    loop
                                                    autoPlay
                                                    muted
                                                >
                                                    <source
                                                        src={
                                                            getVideoUrl(video) || ""
                                                        }
                                                        type="video/mp4"
                                                    />
                                                </video>
                                            </div>
                                        ))}
                                    </div>
                            )}
                        </>
                    ))}
                </div>
            )}
        </>
    );
};

export default Mockup;
